'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _visa = require('./src/visa.tpl');

var _visa2 = _interopRequireDefault(_visa);

var _mastercard = require('./src/mastercard.tpl');

var _mastercard2 = _interopRequireDefault(_mastercard);

var _onlineBank = require('./src/online-bank.tpl');

var _onlineBank2 = _interopRequireDefault(_onlineBank);

var _tt = require('./src/tt.tpl');

var _tt2 = _interopRequireDefault(_tt);

var _paylater = require('./src/paylater.tpl');

var _paylater2 = _interopRequireDefault(_paylater);

var _westernUnion = require('./src/western-union.tpl');

var _westernUnion2 = _interopRequireDefault(_westernUnion);

var _boleto = require('./src/boleto.tpl');

var _boleto2 = _interopRequireDefault(_boleto);

var _ae = require('./src/ae.tpl');

var _ae2 = _interopRequireDefault(_ae);

var _ot = require('./src/ot.tpl');

var _ot2 = _interopRequireDefault(_ot);

var _applePay = require('./src/apple-pay.tpl');

var _applePay2 = _interopRequireDefault(_applePay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SVG_MAP = {
  visa: {
    con: _visa2['default'],
    size: [35, 11]
  },
  mastercard: {
    con: _mastercard2['default'],
    size: [16, 12]
  },
  onlinebank: {
    con: _onlineBank2['default'],
    size: [91, 10]
  },
  tt: {
    con: _tt2['default'],
    size: [20, 10]
  },
  paylater: {
    con: _paylater2['default'],
    size: [47, 10]
  },
  'western-union': {
    con: _westernUnion2['default'],
    size: [104, 10]
  },
  boleto: {
    con: _boleto2['default'],
    size: [18, 10]
  },
  'american-express': {
    con: _ae2['default'],
    size: [50, 50]
  },
  'online-transfer': {
    con: _ot2['default'],
    size: [70, 12]
  },
  'apple-pay': {
    con: _applePay2['default'],
    size: [24, 10]
  }
};

function PaymentIcon(props) {
  var type = props.type,
      className = props.className,
      width = props.width,
      height = props.height,
      others = _objectWithoutProperties(props, ['type', 'className', 'width', 'height']);

  var cls = (0, _classnames2['default'])(_defineProperty({
    'icbu-icon-svg': true
  }, className, className));
  var svgConfig = SVG_MAP[type];
  if (!svgConfig) {
    return null;
  }

  var svgWidth = width || height * svgConfig.size[0] / svgConfig.size[1] || svgConfig.size[0];
  var svgHeight = height || width * svgConfig.size[1] / svgConfig.size[0] || svgConfig.size[1];
  return _react2['default'].createElement('svg', _extends({}, others, {
    className: cls,
    width: svgWidth,
    height: svgHeight,
    viewBox: '0 0 ' + svgConfig.size[0] + ' ' + svgConfig.size[1],
    dangerouslySetInnerHTML: { __html: svgConfig.con }
  }));
}

exports['default'] = PaymentIcon;
module.exports = exports['default'];